export default __webpack_public_path__ + "static/media/close.a22b61b1.svg";